import { Model } from "vue-mc";

export class Campana extends Model {
  defaults() {
    return {
      clave: null
      , descripcion: ""
      , descripcionapp: ""
      , se: null
      , storeid: null
      , payfac: false
      , vendor: null
      , canales: ""
      , dateresini: ""
      , dateresend: ""
      , datelimini: ""
      , datelimend: ""
      , cuotasimple: true
      , benefpref: true
      , contactpref: true
      , status: true
      , fincampanaapp: ""
      , oob: false
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , descripcion: (descripcion) => descripcion
      , descripcionapp: (descripcionapp) => descripcionapp
      , se: (se) => se
      , storeid: (storeid) => storeid
      , payfac: (payfac) => payfac
      , vendor: (vendor) => vendor
      , canales: (canales) => canales
      , dateresini: (dateresini) => dateresini
      , dateresend: (dateresend) => dateresend
      , datelimini: (datelimini) => datelimini
      , datelimend: (datelimend) => datelimend
      , cuotasimple: (cuotasimple) => cuotasimple
      , benefpref: (benefpref) => benefpref
      , contactpref: (contactpref) => contactpref
      , status: (status) => status
      , fincampanaapp: (fincampanaapp) => fincampanaapp
      , oob: (oob) => oob
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/operativos/campana.js